window.joint = require('jointjs');
window.lodash = require('lodash');
window.backbone = require('backbone');
